import axios from 'axios'

export const isFolder = (key: string) => new RegExp('^[^/]*/$').test(key)

export const pathStepBack = (currentPath: string[]) => {
  const newPath = [...currentPath]
  newPath.splice(currentPath.length - 1, 1)
  return newPath.join('/') + '/'
}

// TODO: move this to a getter after switching to mobx
export const pathString = (path: string[]) => {
  return path.join('/') + (path.length ? '/' : '')
}

export const formatLastModifiedDate = (date: Date) => {
  return new Date(date)
}

export const getFileExtension = (fileName: string) => {
  const checkExtension = fileName.match(/\.[0-9a-z]+$/i)
  return checkExtension ? checkExtension[0].replace('.', '') : null
}

export const CancelToken = axios.CancelToken
export const cancelFunctions: Map<string, any> = new Map()